import React from 'react';

import FormProvider from 'routes/Documents/containers/FormProvider';
import FormField from 'containers/FormField';

import GradeableField from '../containers/GradeableField';
import { statusSections } from '../Utils';
import { nowPartialDate } from 'neuro-utils';

const localeAccessor = (sect, grade) => (sect && (grade || grade === 0) ? `status.${sect}.${grade}` : null);

const StatusForm = props => {
  const isInDialog = props.isDialog;

  // Effect to set 'date' field as current date in partial form when creating a new status form
  React.useEffect(() => {
    if (!props.formValues.date && props.editing && Object.keys(props.initialValues).length === 0) {
      props.change('date', nowPartialDate());
    }
  }, []);

  return (
    <FormProvider {...props}>
      <FormField
        name="sections"
        component={GradeableField}
        localeAccessor={localeAccessor}
        sections={statusSections}
        isInDialog={isInDialog}
      />
    </FormProvider>
  );
};

export default StatusForm;
